import { useTranslation } from 'react-i18next';
import IconLeaf from '../../../assets/icons/ic-leaf.svg';

const ContactUs = () => {
  const { t } = useTranslation('header');
  return (
    <div id="contactUs" className="relative">
      <div className="hidden xl:block absolute top-0 -left-[45px]">
        <img src={IconLeaf} alt="leaf" />
      </div>

      <div className="text-center mt-9 xl:mt-[100px] px-4 xl:px-[100px]">
        <h4 className="text-orange-300 font-dancing-script xl:text-[24px] font-bold">
          {t('contact.titleMain')}
        </h4>
        <h2 className="text-primary mt-2 xl:mt-0 text-[24px] xl:text-[32px] font-bold xl:font-extrabold">
          {t('contact.subMain')}
        </h2>
        <div className="flex flex-col mt-4 xl:mt-9 text-[14px] xl:text-[16px] font-semibold text-grey-900">
          <span>{t('contact.openTime')}</span>

          <span>{t('contact.dateTime')}</span>
          <span>{t('contact.address')}</span>
          <span>{t('contact.phoneNumber')}</span>
        </div>

        <div className="mt-4 xl:mt-9">
          <iframe
            title="tanloc-seafood-map"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d8053136.028188573!2d100.48439076176778!3d9.74951612152038!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31420d09c0000001%3A0xc1a8f6416453fe82!2sTan%20Loc%20Restaurant%20_%20Seafood%20Cua%20Dai%20Beach!5e0!3m2!1svi!2s!4v1693448243325!5m2!1svi!2s"
            className="border-none w-full h-[226px] xl:h-[415px]"
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
